import React from 'react';
import { useCachePerformanceQuery } from 'src/api/queries/deliveryAnalyticsQueries';
import { DeliveryAnalyticsFilters } from 'src/types/TDeliveryAnalytics';
import { formatNumberIntl } from 'src/utils/common';
import { AsyncSection, DataAsOfBadge, Section } from '../components/common';
import styles from '../styles.module.scss';

const ms = (v: number) => `${Math.round(v)} ms`;

const CachePerformanceTab: React.FC<{ filters: DeliveryAnalyticsFilters }> = ({ filters }) => {
  const { data, isLoading, error } = useCachePerformanceQuery(filters);
  const isEmpty = !isLoading && !error && (data?.requests ?? 0) === 0;

  return (
    <Section
      title="Cache performance"
      description="Edge cache efficiency and time-to-first-byte for delivered media."
      headerRight={<DataAsOfBadge value={data?.data_as_of} loading={isLoading} />}
    >
      <AsyncSection isLoading={isLoading} error={error} isEmpty={isEmpty}>
        {data && (
          <div className={styles.statGrid}>
            <div className={styles.statCard}>
              <div className={styles.statValue}>
                {(data.cache_hit_rate * 100).toFixed(1)}%
              </div>
              <div className={styles.statLabel}>Cache hit rate</div>
            </div>
            <div className={styles.statCard}>
              <div className={styles.statValue}>{formatNumberIntl(data.requests)}</div>
              <div className={styles.statLabel}>Requests</div>
            </div>
            <div className={styles.statCard}>
              <div className={styles.statValue}>{formatNumberIntl(data.cache_hits)}</div>
              <div className={styles.statLabel}>Cache hits</div>
            </div>
            <div className={styles.statCard}>
              <div className={styles.statValue}>{ms(data.ttfb_ms.p50)}</div>
              <div className={styles.statLabel}>TTFB p50</div>
            </div>
            <div className={styles.statCard}>
              <div className={styles.statValue}>{ms(data.ttfb_ms.p90)}</div>
              <div className={styles.statLabel}>TTFB p90</div>
            </div>
            <div className={styles.statCard}>
              <div className={styles.statValue}>{ms(data.ttfb_ms.p99)}</div>
              <div className={styles.statLabel}>TTFB p99</div>
            </div>
          </div>
        )}
      </AsyncSection>
    </Section>
  );
};

export default CachePerformanceTab;
